// extracted by mini-css-extract-plugin
export default {"fondo":"Inicio_fondo__Tj5FI","InicioBanner":"Inicio_InicioBanner__uOfmx"};